import { MdOutlineKeyboardDoubleArrowLeft } from "react-icons/md"
import { PropTypes } from 'prop-types';
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { fetchScholarshipsData } from "../redux/slice/scholarshipsPage";
import { DecodeHtml } from "../utils/decodeHtml";
import FinCard from "../components/financialAidScholarship/finCard";
import ShowScholarShipCards from "./showScholarShipCards";


const AboutFinAidPlatform = ({ closedate, searchText }) => {
    const dispatch = useDispatch()
    const state = useSelector(state => state.scholarships)

    useEffect(() => {
        const delayDebounceFn = setTimeout(() => {
            console.log(closedate, searchText);

            if (closedate === "" || searchText === "") {
                dispatch(fetchScholarshipsData({ closedate: null, searchText: null }));
            } else {
                dispatch(fetchScholarshipsData({
                    closedate: closedate,
                    searchText: searchText
                }));
            }
            // Send Axios request here
        }, 1000)


        return () => clearTimeout(delayDebounceFn)

    }, [closedate, searchText, dispatch]);

    const finAidScholarship = state?.data?.data




    return (
        <div className="w-full bg-gray-100 px-4 py-8 lg:p-16 flex flex-col items-center gap-8">
            <div className="flex-col justify-center items-center gap-4 flex">
                <h1 className="text-center text-blue-700 text-sm font-bold  uppercase tracking-widest flex items-center gap-1">Scholarships  <MdOutlineKeyboardDoubleArrowLeft size={22} /></h1>
                <div className="flex flex-col items-center gap-8 w-full px-4 py-8 lg:py-16">
                    {

                        state?.isLoading ?
                        <div className="size-12 border-4 border-gray-400 border-t-[#1d4ed8] animate-spin rounded-full" />
                        :
                        finAidScholarship && finAidScholarship?.map((scholarship, index) => {
                            return <ShowScholarShipCards key={index} scholarship={scholarship} />
                        })
                    }
                </div>
            </div>
        </div>
    )
}
AboutFinAidPlatform.propTypes = {
    closedate: PropTypes.string,
    searchText: PropTypes.string
}
export default AboutFinAidPlatform